import React from "react";
import "./src/styles/global.css";
import HoldingPage from "./src/components/HoldingPage";

export const wrapPageElement = () => <HoldingPage />;
